import { useEffect, useState } from 'react';

const useProgressBar = (isUploadingOrDeleting: boolean) => {
    const [ progress, setProgress ] = useState<number>(0);

    const setIntervalForProgress = (setProgress: React.Dispatch<React.SetStateAction<number>>) => {
        return setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress === 100) {
                    return 0;
                }
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 90);
            });
        }, 100);
    };

    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (isUploadingOrDeleting) {
            timer = setIntervalForProgress(setProgress);
        } else {
            setProgress(0);
        }

        return (() => {
            clearInterval(timer);
        });
    }, [ progress, isUploadingOrDeleting ]);

    return { progress };
};

export default useProgressBar;
